import React from 'react';
import { Box, Typography, Container, Grid, Card, CardMedia, CardContent, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";

// Hero Section styled component
const HeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '50vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  backgroundImage: `url(${process.env.PUBLIC_URL}/Yuvaexpo-4.png)`,
  padding: theme.spacing(4),
  marginBottom: theme.spacing(8),
  "::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1,
  },
  "& > *": {
    position: "relative",
    zIndex: 2,
  },
}));

// Custom styled components
const ContentSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  backgroundColor: theme.palette.background.default,
}));

const FeatureCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px)',
  },
}));
const IconWrapper = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  background: theme.palette.background.paper,
  margin: "auto",  // Add this line
}));
const YuvaExpoPage = () => {
  const features = [
    {
      title: 'Event Management',
      description: 'Gain hands-on experience in organizing and managing large-scale events.',
      image: '/Yuvaexpo-1.jpg',
    },
    {
      title: 'Leadership Development',
      description: 'Develop crucial leadership skills through practical experience and mentorship.',
      image: '/Yuvaexpo-2.jpg',
    },
    {
      title: 'Industry Connection',
      description: 'Connect with experts and professionals from various industries.',
      image: '/Yuvaexpo-3.jpg',
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <HeroSection>
        <Box sx={{ textAlign: 'center', maxWidth: 800 }}>
        <IconWrapper>
                        <EmojiPeopleIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
          <Typography variant="h2" component="h1" gutterBottom>
            YUVA Expo 
          </Typography>
          <Typography variant="h5">
            Shaping Future Leaders Through Experiential Learning
          </Typography>
        </Box>
      </HeroSection>

      {/* Main Content */}
      <Container>
        <ContentSection>
          <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 6 }}>
            About YUVA Expo
          </Typography>
          <Paper elevation={3} sx={{ p: 4, mb: 8, borderRadius: 2 }}>
            <Typography variant="body1" paragraph>
              YUVA Expo, an initiative by NYCS, is a dynamic platform designed to inspire and engage college students in event management and entrepreneurship. This vibrant event provides young individuals with opportunities to showcase their talents, develop leadership skills, and gain hands-on experience in organizing and managing large-scale events.
            </Typography>
            <Typography variant="body1" paragraph>
              Through exhibitions, workshops, and interactive sessions, YUVA Expo fosters innovation, collaboration, and professional growth among students. It serves as a bridge between academia and industry, connecting aspiring youth with experts, mentors, and potential career opportunities.
            </Typography>
          </Paper>

          {/* Feature Cards */}
          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <FeatureCard>
                  <CardMedia
                    component="img"
                    height="200"
                    image={feature.image}
                    alt={feature.title}
                  />
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </ContentSection>

        {/* Call to Action */}
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h5" gutterBottom>
            Join us in shaping the future of young leaders through experiential learning and real-world exposure.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default YuvaExpoPage;